import { useState } from "react"
import { Link } from "react-router-dom"
import TournamentInfoStandings from "./TournamentInfoStandings.jsx"
import TournamentInfoMatches from "./TournamentInfoMatches.jsx"

export default function TournamentInfo({groupId, tournamentId, onBack}) {
  const initialTab = new URLSearchParams(window.location.search).get("tab") === "matches" ? "matches" : "standings"
  const [activeTab, setActiveTab] = useState(initialTab)

  const handleTabClick = (event, tab) => {
    event?.preventDefault()
    setActiveTab(tab)
    window.history.replaceState(null, "Bolão da Copa - Detalhes do Torneio", "?group_id=" + groupId + "&tournament_info=1&tab=" + tab)
  }

  return (
    <>
      <div className="flex flex-row justify-between w-full">
        <div className={`w-1/2 text-center mr-1 rounded-t-lg ${activeTab === "standings" ? "bg-slate-100 font-bold" : "bg-white hover:bg-slate-100 hover:underline"}`}>
          <Link onClick={(event) => handleTabClick(event, "standings")} className="block p-2">Classificação</Link>
        </div>
        <div className={`w-1/2 text-center ml-1 rounded-t-lg ${activeTab === "matches" ? "bg-slate-100 font-bold" : "bg-white hover:bg-slate-100 hover:underline"}`}>
          <Link onClick={(event) => handleTabClick(event, "matches")} className="block p-2">Jogos</Link>
        </div>
      </div>

      {activeTab === "standings" && (
        <TournamentInfoStandings tournamentId={tournamentId} />
      )}
      {activeTab === "matches" && (
        <TournamentInfoMatches tournamentId={tournamentId} />
      )}

      {onBack && (
        <div className="text-center mb-2">
          <Link onClick={() => onBack()} className="text-green-600 underline hover:no-underline text-sm">voltar para o Bolão</Link>
        </div>
      )}
    </>
  )
}
  